<script>
import { Line } from "vue-chartjs";

export default {
  name: "LinePlot",
  extends: Line,
  props: {
    simulations: {
      type: Array,
      required: true
    },
    statsType: {
      type: String,
      required: true
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      colors: [
        "0, 0, 0",
        "230, 159, 0",
        "86, 180, 233",
        "0, 158, 115",
        "240, 228, 66",
        "0, 114, 178",
        "213, 94, 0",
        "204, 121, 167"
      ],
      initialChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0 // disables bezier curves
          }
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Damage"
              },
              type: "linear",
              ticks: {
                beginAtZero: true,
                min: 0
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Probability (%)"
              },
              type: "linear",
              ticks: {
                beginAtZero: true,
                min: 0
              }
            }
          ]
        }
      }
    };
  },
  computed: {
    chartOptions() {
      const options = this.initialChartOptions;
      options.scales.xAxes[0].scaleLabel.labelString = this.xAxesLabel;
      return options;
    },
    areAllStatsLoaded() {
      return this.$store.getters.areAllStatsLoaded;
    },
    chartData() {
      const datasets = [];
      this.simulations
        .filter(simulation => Boolean(simulation.stats))
        .forEach((simulation, index) => {
          const color = this.colors[index % this.colors.length];
          const stats = this.getSimulationStats(simulation);
          const dataset = {
            label: simulation.label,
            data: stats,
            borderColor: "rgba(" + color + ",1)",
            backgroundColor: "rgba(" + color + ",0.2)"
          };
          datasets.push(dataset);
        });
      return { datasets: datasets };
    },
    xAxesLabel() {
      const label = {
        damage: "Damage",
        "minimum-damage": "Minimum Damage"
      };
      return label[this.statsType];
    },
    canChartBeUpdated() {
      return this.display && this.areAllStatsLoaded;
    }
  },
  methods: {
    updateChart() {
      if (!this.canChartBeUpdated) return;
      this.renderChart(this.chartData, this.chartOptions);
    },
    getSimulationStats(simulation) {
      const damageStatsMethod = {
        damage: this.getDamageStats,
        "minimum-damage": this.getMinimumDamageStats
      };
      const damageStats = damageStatsMethod[this.statsType];
      return damageStats(simulation);
    },
    getDamageStats(simulation) {
      return simulation.statsAxis;
    },
    getMinimumDamageStats(simulation) {
      return simulation.cumulativeStatsAxis;
    }
  },
  watch: {
    chartData: "updateChart",
    display: "updateChart"
  }
};
</script>
